import React, { Component } from 'react'
import styled from 'styled-components'
import Navigation from '../Topbar/Nav'
import SearchBox from '../Topbar/SearchBox'

const Wrap = styled.div`
  position: fixed;
  top: 0;
  width: 100%;

  background-color: #333333;
  height: 56px;
`

class Topbar extends Component {
  render () {
    return (
      <Wrap>
        <Navigation />
        <SearchBox />
      </Wrap>
    )
  }
}

export default Topbar



// WEBPACK FOOTER //
// ./src/components/Topbar/index.js